"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optinMonsterReset = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
/* 
To be used in conjunction with optinMonsterScript. 
Example implementation in Site.jsx:

const currentEnv = process.env.REACT_APP_ENV;
const allowedEnvs = ['production', 'local'];

function Site() {
    optinMonsterReset({ currentEnv, allowedEnvs });
*/

const optinMonsterReset = _ref => {
  let {
    currentEnv,
    allowedEnvs
  } = _ref;
  const location = (0, _reactRouterDom.useLocation)();
  (0, _react.useEffect)(() => {
    if (allowedEnvs.includes(currentEnv)) {
      const checkOptinMonster = setInterval(() => {
        if (window.om2863_27375) {
          window.om2863_27375.reset();
          clearInterval(checkOptinMonster);
        }
      }, 1000);
      return () => {
        clearInterval(checkOptinMonster);
      };
    }
  }, [currentEnv, allowedEnvs, location]);
};
exports.optinMonsterReset = optinMonsterReset;